import { CSSProperties, MutableRefObject, ReactNode } from "react";
import { FormInstance, Rule } from "antd/lib/form";
import { ColumnType } from "antd/lib/table";
import { SimpleFormItemProps } from "../SimpleForm";
import { IObject } from "../constants/interface";
import { ITotalItem } from "../SuperTable/subpage/tableTotal";

export const mainFormKey = 'main';
// change类型
export type onValuesChange = (
  name: any,
  value: any,
  mainKey: any,
  childrenKey: any,
  form: FormInstance,
  record: any,
) => void;
/** 可编辑主子表支持的表单类型 */
export type EditVirtualMainTableFormItemType =
  | 'Input'
  | 'InputNumber'
  | 'Select'
  | 'SuperSelect'
  | 'SelectTable'
  | 'SuperSelectTable'
  | 'Switch'
  | 'TextArea'
  | 'UploadImage'
  | 'UploadImages'
  | 'Upload'
  | 'Address'
  | 'CheckboxGroup'
  | 'Checkbox'
  | 'DatePicker'
  | 'RangePicker'
  | 'TimePicker'
  | 'SelectCombination'
  | 'SuperAutoComplete';
/** 主表行 */
export type rowRenderType = (record: any) => ReactNode;
export const MAIN_ROW_KEY: string = 'isMainTable';
export const ADD_CHILDREN_KEY: string = 'isAddChildren';
export const EMPTY_CHILDREN_KEY: string = 'isEmptyChildren';
export const TRAILER_ROW_KEY = '__isTrailerRowKey';
export const ALL_CHILDREN_KEY: string = 'allChildren';
export const ADD_KEY = 'add';
export const EMPTY_KEY = 'empty';
export const TRAILER_KEY = 'trailer';
export type deleteType = 'ALL' | 'MAIN' | 'CHILDREN';

export interface EditVirtualMainTableAction {
  /**
   * 新增主表行(一行或多行)
   * @param addItem 新增数据
   * @returns 
   */
  addMain: (addItem?: IObject | IObject[]) => void;
  /**
   * 新增子表行(一行或多行)
   * @param mainKey 主表key
   * @param addItem 新增数据
   * @returns 
   */
  addChildren: (mainKey: string, addItem?: IObject | IObject[]) => void;
  /**
   * 在原有数据基础上追加主子表数据
   * @param appendItem 追加数据
   * @returns 
   */
  append: (appendItem: IObject[]) => void;
  /**
   * 覆盖主子表数据
   * @param addItem 新数据
   * @returns 
   */
  cover: (addItem?: IObject[]) => void;
  /**
   * 删除主表行
   * @param record 要删除的行数据 
   * @returns 
   */
  /**
   * 替换可编辑表数据
   * @param newDataSource 新数据
   * @returns 
   */
  changeDataSource: (newDataSource: any[]) => void;
  /**
   * 删除
   * @param record 当前行数据
   * @returns 
   */
  delete: (record: any) => void;
  /** 提交 */
  submit: () => Promise<any[] | false>;
  /**
   * 清空主表下的子表数据
   * @param mainKey 主表key
   * @returns 
   */
  emptyMainChildren: (mainKey: string) => void;
  /** 清空数据 */
  empty: () => void;
  /**
   * 获取数据
   * @param filterDeleteData 是否过滤已删除数据
   * @returns 
   */
  getDataSource: (filterDeleteData?: boolean) => any[];
  /**
   * 修改统计数据
   * @param dataSource 数据源(不传这默认使用当前表格的数据)
   * @returns 
   */
  changeTotal: (dataSource?: any[]) => void;
  /**
   * 修改单行主表表单数据
   * @param mainKey 主表key
   * @param values 修改数据
   * @returns 
   */
  setMainValues: (mainKey: string, values: any) => void;
  /**
   * 修改单行子表表单数据
   * @param childrenKey 子表key
   * @param values 修改数据
   * @returns 
   */
  setMainChildrenValues: (childrenKey: string, values: any) => void;
  /**
   * 修改主表下所有子表的表单数据
   * @param mainKey 
   * @param values 
   * @returns 
   */
  setMainChildrensValues: (mainKey: string, values: any) => void;
  /** form表单 */
  form: FormInstance;
};
export type EditVirtualMainTableActionType = EditVirtualMainTableAction | undefined;
/** 可编辑主子表 */
export interface EditVirtualMainTableProps extends BaseTotalTableProps {
  /** 对象句柄 */
  actionRef?: MutableRefObject<EditVirtualMainTableActionType>;
  /** 高度 */
  height?: number | string;
  /** 数据 */
  dataSource?: any[];
  /** 列配置 */
  columns?: EditVirtualMainTableColumnType[];
  /** 初始时，是否展开所有行 */
  defaultExpandAllRows?: boolean;
  /** 是否禁用 */
  disabled?: boolean;
  /** 是否隐藏操作按钮 */
  hideAdd?: boolean;
  /** 操作按钮图标 */
  addIcon?: ReactNode;
  /** 操作列配置 */
  operation?: ColumnType<any> | false;
  /** 是否禁用当前行操作 */
  disabledOperation?: (record: any) => boolean;
  /** 可删除的行 */
  deleteType?: deleteType;
  /** 自定义标题 */
  operationTitle?: ReactNode;
  /** 操作列宽度 */
  operationWidth?: number;
  /** 额外类名 */
  className?: string;
  /** 是否展示外边框和列边框 */
  bordered?: boolean;
  /** 额外样式 */
  style?: CSSProperties;
  /** 是否展示添加一行按钮 */
  showAddSubRow?: boolean;
  /** 添加一行按钮文字 */
  addSubRowText?: ReactNode;
  /** 子表数据为空时时否展示默认提示行 */
  showEmptySubRow?: boolean;
  /** 子表数据为空时时展示的提示文字 */
  emptySubRowText?: ReactNode;
  /** 每个主表下需要添加多少行虚假尾标才能补齐下拉不能到底问题  （临时解决下拉不能到底问题） */
  trailerRow?: number;
  /** 主表自定义行 */
  rowRender?: rowRenderType;
  /** 展示添加一行按钮后部分行隐藏按钮的方法 */
  hiddenAddSubRow?: (mainData: any) => boolean;
  /** 点击添加之后数据添加之前时触发 */
  onAdd?: () => void;
  /** 点击添加子行之后数据添加之前时触发 */
  onAddChildren?: (mainData: any) => void;
  /** 点击删除时触发，可控制是否删除 */
  onDelete?: (record: any, mainIndex: number, childIndex?: number) => boolean;
  /** 值改变 */
  onValuesChange?: onValuesChange;
};
/** 可编辑主子表列配置 */
export interface EditVirtualMainTableColumnType extends ColumnType<any>, Omit<SimpleFormItemProps, 'disabledRender'> {
  /** 是否可编辑 */
  editable?: boolean;
  /** 是否禁用表单 */
  disabled?: boolean | ((record: any) => boolean);
  /** 禁用时用哪个字段显示 */
  disabledRender?: ReactNode | ((record: any) => ReactNode);
  /** 表单类型 */
  formItemType?: EditVirtualMainTableFormItemType;
  /** 自定义验证条件 */
  formatRules?: (record: any) => Rule[];
  rowIndex?: any;
  dataIndex?: string | string[];
};
/** 列表行配置 */
export interface TableRowProps {
  /** 行唯一标识 */
  'data-row-key': string;
  /** 是否禁用 */
  disabled?: boolean;
};
/** 列表单元格配置 */
export interface TableCellProps {
  /** 是否可编辑 */
  editable?: boolean;
  /** 当前行数据 */
  record?: any;
  /** 是否禁用表单 */
  disabled?: boolean;
  /** 禁用时用哪个字段显示 */
  disabledRender?: ReactNode | ((record: any) => ReactNode);
  /** 表单类型 */
  formItemType?: EditVirtualMainTableFormItemType;
  /** 表单props */
  SimpleFormItemProps?: SimpleFormItemProps;
  /** form表单 */
  form?: FormInstance;
  rowIndex?: string;
  children?: any;
  style?: CSSProperties;
};
/** Dispatch类型 */
export type EditVirtualMainTableDispatchType =
  | 'init'
  | 'addRow'
  | 'deleteRow'
  | 'addForm'
  | 'deleteForm'
  | 'addExpandedRowKeys'
  | 'deleteExpandedRowKeys'
  | 'addChildren'
  | 'deleteChildren'
  | 'emptyRow'
  | 'empty'
  | 'append'
  | 'cover'
  | 'changeData'
  | 'change';
/** Payload数据 */
export interface IEditVirtualMainTablePayload {
  /** 当前标记到的行数 */
  flagIndex?: number;
  /** 初始值 */
  dataSource?: any[];
  /** 添加值 */
  addItem?: any;
  /** 追加数据 */
  appendItem?: any[];
  /** form表单 */
  form?: FormInstance;
  /** 要修改的展开接口 */
  updateExpandedRowKeys?: string | string[];
  /** 主表id */
  mainKey?: string;
  /** 子表id */
  childrenKey?: string;
  /** 初始时是否默认展开全部 */
  defaultExpandAllRows?: boolean;
  /** 是否展示添加一行按钮 */
  showAddSubRow?: boolean;
  /** 子表数据为空时是否展示默认提示行 */
  showEmptySubRow?: boolean;
  /** 修改的主表数据 */
  changeMainItem?: any;
  /** 修改的子表数据 */
  changeChildrenItem?: any;
  /** 虚拟尾行行数 */
  trailerRow?: number;
}

/** 统计 */
export interface BaseTotalTableProps {
  /** 需要总计的字段 */
  totalKeys?: ITotalItem[];
  /** 第几列显示合计 */
  totalIndex?: number;
  /** 合计列展示文字 */
  totalText?: ReactNode;
  /** 处理统计数据 */
  formatTotalData?: (dataSource?: any[]) => any;
}